"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var TabBar_1 = require("../../atoms/_TabBar/TabBar");

var GallerySlider_1 = require("../GallerySlider");

var Stateful_1 = require("./Stateful");

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);

  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.uuid = props.id || uniqid_1["default"]("Tabs-");
    return _this;
  }

  Tabs.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        openIndex = _a.openIndex,
        isMobile = _a.isMobile;
    var ids = React.Children.map(children, function (child, i) {
      return child.props.id || _this.uuid + "-" + i;
    });
    return isMobile ? React.createElement(GallerySlider_1.GallerySlider, {
      id: this.uuid,
      initialSlide: openIndex,
      onChange: this.props.onChange,
      slidesToDisplay: GallerySlider_1.GallerySlider.SlidesToDisplay.NEUGELB
    }, React.Children.map(children, function (child) {
      return React.createElement("div", null, child.props.children);
    })) : React.createElement("div", {
      id: this.uuid,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "tabs", className])
    }, React.createElement(TabBar_1.TabBar, {
      role: "tablist",
      openIndex: openIndex,
      indicatorHelperLine: true,
      onKeyDown: this.props.onChange
    }, React.Children.map(children, function (child, i) {
      var label = child.props.label;
      var idTab = ids[i];
      var idPanel = ids[i] + "-Panel";
      return React.createElement(TabBar_1.TabBar.Item, {
        id: idTab,
        key: child.key,
        label: label,
        htmlAttrs: {
          role: "tab",
          onClick: function onClick(e) {
            return _this.props.onChange(i, e);
          }
        },
        "aria-controls": idPanel,
        "aria-selected": true
      });
    })), React.createElement("div", null, React.Children.map(children, function (child, i) {
      var idTab = ids[i];
      var idPanel = ids[i] + "-Panel";
      var active = openIndex === i;
      return active && React.createElement(Tabs.Tab, __assign({}, child.props, {
        "aria-expanded": active,
        "aria-labelledby": idTab,
        className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "tabs-panel", active && CSSPrefix_1.lsgPre + "tabs-panel__active"]),
        id: idPanel,
        key: child.key,
        role: "tabpanel",
        tabIndex: active ? 0 : -1
      }));
    })));
  };

  Tabs.defaultProps = {
    onChange: function onChange() {
      /* empty */
    },
    isMobile: false
  };
  Tabs.Stateful = Stateful_1.Stateful;

  Tabs.Tab = function (props) {
    return React.createElement("div", __assign({}, props, {
      key: props.label
    }));
  };

  return Tabs;
}(React.Component);

exports.Tabs = Tabs;
Tabs.Tab.displayName = "Tabs.Tab";